import { render, staticRenderFns } from "./ToFindOut.vue?vue&type=template&id=3b209672&scoped=true&"
import script from "./ToFindOut.vue?vue&type=script&lang=js&"
export * from "./ToFindOut.vue?vue&type=script&lang=js&"
import style0 from "./ToFindOut.vue?vue&type=style&index=0&id=3b209672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b209672",
  null
  
)

export default component.exports